import ChargeInvoiceService from '@/services/charges/charge-invoice.service';
import { useToggle } from '@/composables/useToggle';
import { readonly } from 'vue';

export const useManifestHasInvoicedCharges = () => {
  const [hasInvoicedCharges, toggleInvoicedCharges] = useToggle(false);

  const checkManifestHasInvoicedCharges = async (id: string) => {
    try {
      const {
        data: { status },
      } = await ChargeInvoiceService.hasActiveCharges(id);
      toggleInvoicedCharges(status);
    } catch (e) {
      toggleInvoicedCharges(false);
    }
  };

  return { hasInvoicedCharges: readonly(hasInvoicedCharges), checkManifestHasInvoicedCharges };
};
